"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidLocale = void 0;
const getValidLocale = (str) => {
    switch (str) {
        case 'en':
        case 'it':
        case 'ru':
        case 'de':
        case 'fr':
        case 'pt':
        case 'es':
        case 'pl':
            return str;
        default:
            return 'en';
    }
};
exports.getValidLocale = getValidLocale;
